import React, {Component} from "react";
import {Fragment} from "react";
import {payment_methods, statuses} from "./constants";

class RefundOption extends Component{
    render(){
        const {pastReservation, changePopUpStatus, translate } = this.props;
        if(pastReservation.payment_method === payment_methods.CREDIT_CARD ||  pastReservation.payment_method === payment_methods.INSTALLMENT){
            return <Fragment>
                <div className="right-hr"></div>
                <div className="options cursor-pointer"
                     onClick={(e) => changePopUpStatus(e, "open", "refund-overlay", pastReservation)}>
                    <p
                        className="upper text-center cursor-pointer">
                        <i className="fas fa-dollar-sign fa-fw"></i>
                    </p>
                    <h6 className="capitalized dark-blue">{translate("refund")}</h6>
                </div>
            </Fragment>
        }
        return null;
    }
}


export default RefundOption;